import { render, staticRenderFns } from "./AvatarMaker.vue?vue&type=template&id=37406886&scoped=true&"
import script from "./AvatarMaker.vue?vue&type=script&lang=js&"
export * from "./AvatarMaker.vue?vue&type=script&lang=js&"
import style0 from "./AvatarMaker.vue?vue&type=style&index=0&id=37406886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37406886",
  null
  
)

export default component.exports